// Consumer Search reducer

import * as types from '../actions/actionTypes';

const INITIAL_STATE = {
    params: {},
    result: null,
    error: null,
    loading: false,
    page: 0,
    rowsPerPage: 10,
    order: null,
    orderBy: null,
};

export default function searchReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.SEARCH_PARAMS: {
            return {
                ...state,
                params: action.params,
                result: null,
                error: null,
                loading: true,
            };
        }

        case types.SEARCH_RESULT: {
            return {
                ...state,
                result: action.result,
                error: null,
                loading: false,
                page: 0,
            };
        }

        case types.SEARCH_ERROR: {
            return {
                ...state,
                result: null,
                error: action.error,
                loading: false,
            };
        }

        case types.SEARCH_CLEAR: {
            return {
                ...state,
                result: null,
                params: {},
                page: 0,
                order: null,
                orderBy: null,
            };
        }

        case types.SEARCH_SET_PAGE: {
            return {
                ...state,
                page: action.page,
            };
        }

        case types.SEARCH_SET_ROWS_PER_PAGE: {
            return {
                ...state,
                rowsPerPage: action.rowsPerPage,
            };
        }

        case types.SEARCH_SET_ORDER: {
            return {
                ...state,
                order: action.order,
            };
        }

        case types.SEARCH_SET_ORDER_BY: {
            return {
                ...state,
                orderBy: action.orderBy,
            };
        }

        default:
            return state;
    }
}
